// AI: This custom directive replaces the old, JIT-incompatible ngx-feature-toggle library.
import { Directive, Input, TemplateRef, ViewContainerRef, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';

@Directive({
  selector: '[appFeatureFlag]'
})
export class FeatureFlagDirective implements OnInit {
  @Input() appFeatureFlag: string;

  constructor(
    private templateRef: TemplateRef<unknown>,
    private viewContainer: ViewContainerRef
  ) {}

  ngOnInit() {
    const featureFlags = environment.features || {};
    let flagName = this.appFeatureFlag;
    let showIfEnabled = true;

    if (flagName.startsWith('!')) {
      flagName = flagName.substring(1);
      showIfEnabled = false;
    }

    const isEnabled = !!featureFlags[flagName];

    if ((isEnabled && showIfEnabled) || (!isEnabled && !showIfEnabled)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
